import { useT } from "../../shared/i18n";
import { Button, Icons } from "../../shared/ui";

/**
 * Home before the owner has picked any section on this device. The buttons
 * live in the content: the tab bar occupies the bottom edge.
 */
export function FirstRun({
  onChoose,
  onCreate,
}: {
  onChoose: () => void;
  onCreate: () => void;
}) {
  const t = useT();
  return (
    <main className="flex flex-1 flex-col items-center justify-center gap-3 px-6 py-12 text-center">
      <span className="flex size-[72px] items-center justify-center rounded-full bg-accent-subtle text-accent-fg">
        <Icons.Search size={32} />
      </span>
      <h1 className="text-h3 font-bold">{t("sections.firstRun.title")}</h1>
      <p className="max-w-sm text-body text-fg-muted">
        {t("sections.firstRun.body")}
      </p>
      <div className="mt-4 flex w-full max-w-sm flex-col gap-3">
        <Button onClick={onChoose}>{t("sections.firstRun.choose")}</Button>
        <Button variant="secondary" onClick={onCreate}>
          {t("sections.firstRun.create")}
        </Button>
      </div>
    </main>
  );
}
